// WO-2942: tell the database which app this session is acting for, so the app_scope claim in the
// JWT matches. Best effort and safe before the claim path is applied: if the function does not
// exist yet (migration 20261029b not applied) it stops trying for this page load and nothing
// changes, because the contact adapter keeps filtering by an explicit owner either way.
let unavailable = false;
let last = null;

export async function requestAppScope(client, scope) {
  if (unavailable || !scope || scope === last || !client || typeof client.rpc !== 'function') return false;
  try {
    const { error } = await client.rpc('select_app_scope', { p_scope: scope });
    if (error) { unavailable = true; return false; }
    last = scope;
    if (client.auth && typeof client.auth.refreshSession === 'function') await client.auth.refreshSession();
    return true;
  } catch (e) { unavailable = true; return false; }
}
